module.exports = __webpack_public_path__ + "img/reduce-congestion-depth.49f46815.png";